import { render } from "./message-rating-number.vue?vue&type=template&id=e4200ba2&scoped=true&ts=true"
import script from "./message-rating-number.vue?vue&type=script&lang=ts"
export * from "./message-rating-number.vue?vue&type=script&lang=ts"

import "./message-rating-number.vue?vue&type=style&index=0&id=e4200ba2&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4200ba2"]])

export default __exports__